/* eslint-disable @typescript-eslint/default-param-last */
import { IApiState } from 'store/types';
import { IApiAction, IApiActionPayload, IApiErrorPayloadWithCode, RequestStatus } from 'types';
import { ApiActions } from './types';

const initialState: IApiState = {
  requests: {},
};

export const apiReducer = (state: IApiState = initialState, action: IApiAction): IApiState => {
  switch (action.type) {
    case ApiActions.CLEAR_REQUEST: {
      const payload = action.payload as IApiActionPayload;
      const { [payload.requestName]: removedRequest, ...rest } = state.requests;
      return {
        ...state,
        requests: rest,
      };
    }
    case ApiActions.CLEAR_ALL_REQUESTS: {
      return initialState;
    }
    default: {
      const matches = /(.*)_(REQUEST|SUCCESS|FAIL)/.exec(action.type);
      if (!matches) return state;
      const [, requestName, requestState] = matches;
      return {
        ...state,
        requests: {
          ...state.requests,
          [requestName]: {
            status: requestState === 'REQUEST' ? RequestStatus.PENDING : requestState === 'SUCCESS' ? RequestStatus.SUCCESS : requestState === 'FAIL' ? RequestStatus.FAILED : RequestStatus.UNINITIATED,
            isLoading: requestState === 'REQUEST',
            errors: requestState === 'FAIL' ? (action.payload as IApiErrorPayloadWithCode) : null,
          },
        },
      };
    }
  }
};
